export const API_PRO='http://tienda-shantal.com/store/api';
export const API_LOCAL='http://localhost:4005/api';
export const API_DEV='http://tienda-shantal.com/test/store/api';
//export const API_PRO='http://tienda-shantal.com/test/store/api';